// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pPe4-","colBig":"styles_colBig__1HPIX","colSmall":"styles_colSmall__3i2-L"};